module.exports = __webpack_public_path__ + "static/img/h23.ad14191.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h23.jpg
// module id = JQc9
// module chunks = 0